import labelInputMixin from "../_mixin";
export default {
  name: "LabelInput",
  mixins: [labelInputMixin],
  methods: {
    renderInput(h, data) {
      return h("el-input", data);
    }
  }
};
